module.exports = __webpack_public_path__ + "img/sirius.26e93a77.jpg";